import {useRef} from 'react';

import {ChangeOrderArrows} from '../../ChangeOrderArrows/ChangeOrderArrows';
import {downloadFile} from '../helpers';
import {RemoveDocument} from '../RemoveDocument/RemoveDocument';
import '../Documents.scss';


const getContentAlert = (oldIndex, newIndex, name) => {
  return `Przesunięto załącznik ${name} z pozycji nr ${oldIndex} na pozycję nr ${newIndex}.`
};


export const DocumentOnList = ({
                                 canRemove,
  // this one is necessary if canRemove and not onlyRemoveFromList
  controlUuid,
  disabled,
  document,
  onlyRemoveFromList,
  onRemoveDocument,
  withIndexOnList,
  // this one is necessary if withIndexOnList or withMoveIcons
  index,
  // these are necessary if withMoveIcons
  isFirst,
  isLast,
  withMoveIcons,
  onMoveDown,
  onMoveUp,
}) => {
  const documentContainerRef = useRef();
  const fileName = document.file?.fileName || '-';
  return (
    <div className={`row my-2 ${canRemove ? 'documents__row' : ''}`} key={document.id} ref={documentContainerRef}>
      <div className={`col-${withMoveIcons && canRemove ? '8' : '10'}`}>
        {(withMoveIcons || withIndexOnList) && `${index}.`}
        <button
          className="btn documents__doc-name"
          type="button"
          onClick={() => document.file
            ? downloadFile(documentContainerRef.current, document.file.id, fileName)
            : {}
          }
        >
          <span className="sr-only">Plik </span>{fileName}<span className="sr-only"> Kliknij, aby go pobrać.</span>
        </button>
      </div>
      {withMoveIcons &&
        <div className='col-2 documents__flex-right'>
          <ChangeOrderArrows
            index={index}
            isFirst={isFirst}
            isLast={isLast}
            srOnlySuffix={`załącznik nr ${index} o nazwie: ${fileName}`}
            getContentAlert={(oldIndex, newIndex) => getContentAlert(oldIndex, newIndex, fileName)}
            onMoveDown={onMoveDown}
            onMoveUp={onMoveUp}
          />
        </div>
      }
      {canRemove &&
        <div className='col-2 documents__flex-right'>
          {onlyRemoveFromList
            ? (
              <button
                className="btn delete-btn documents__delete-btn"
                disabled={disabled}
                onClick={() => onRemoveDocument(document.id)}
              >
                Usuń<span className="sr-only"> plik {fileName}</span>
              </button>
            ) : (
              <RemoveDocument
                  controlUuid={controlUuid}
                  documentId={document.id}
                  documentName={fileName}
                  onRemove={onRemoveDocument}
              />
              )
          }
        </div>
      }
    </div>
  )
};
